// extracted by mini-css-extract-plugin
export default {"container":"NJ-z","topReviewHeading":"OJ-z","criticalReview":"PJ-z","favorableReview":"QJ-z","vsSeparator":"RJ-z"};